// Generated by purs version 0.15.0
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Restaumatic_Prelude_Specular from "../Restaumatic.Prelude.Specular/index.js";
import * as Specular_Dom_Element from "../Specular.Dom.Element/index.js";
var spinnerIconExtra = function (extraClass) {
    return Specular_Dom_Element.el("span")([ Data_Semigroup.append(Specular_Dom_Element.semigroupProp)(Specular_Dom_Element.attr("aria-hidden")("true"))(Specular_Dom_Element.class_("icon-spinner icon-spin ")), Specular_Dom_Element.class_(extraClass) ])(Restaumatic_Prelude_Specular.wempty);
};
var spinnerIcon = /* #__PURE__ */ spinnerIconExtra("");
export {
    spinnerIcon,
    spinnerIconExtra
};
//# sourceMappingURL=index.js.map
